import React from 'react'
import Footer from '../components/footerComponent/footer'
import Payments from '../components/paymentsComponent/paymentsComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function PaymentsPage() {
    return (
        <Layout>
            <Header/>
            <Payments/>
            <Footer/>
        </Layout>
    );
};